import { Grid, Typography, styled, useMediaQuery } from '@mui/material';

import { useState } from 'react';

type SwitcherProps = {
  option1: string;
  option2: string;
  compactHeight?: boolean;
  onChange: (option: string) => void;
};

const Switcher = (props: SwitcherProps) => {
  const { option1, option2, onChange } = props;
  const [option, setOption] = useState(option1);

  const handleOptionChange = (newOption: string) => {
    setOption((prevState) => {
      if (prevState === newOption) {
        return newOption;
      }
      return newOption;
    });
    onChange(newOption);
  };

  const StyledGridContainer = styled(Grid)(() => ({
    width: '181px',
    height: '30px',
    borderRadius: '30px',
    border: '1px solid #9747FF80',
    color: '#9747FF',
    background: '#FFFFFF',
    padding: '4px 3px',
    gap: '2px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }));

  const StyledGridButton = styled(Grid)(() => ({
    cursor: 'pointer',
    padding: '3px 4px',
    borderRadius: '12px',
    height: '24px',
    width: 'auto',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    transition: 'background-color 0.3s, border-color 0.3s',
  }));

  const optionActive = {
    backgroundColor: '#9747FF',
    border: '1px solid #00000042',
    color: '#FFFFFF',
  };

  return (
    <StyledGridContainer container>
      <StyledGridButton
        item
        container
        onClick={handleOptionChange.bind(null, option1)}
        sx={option === option1 ? optionActive : {}}
      >
        <Typography
          fontFamily="Inter"
          fontWeight="600"
          fontSize="13px"
          lineHeight="18px"
          letterSpacing="0.16px"
        >
          {option1.length > 17 ? ` ${option1.slice(0, 17)}..` : option1}
        </Typography>
      </StyledGridButton>
      <StyledGridButton
        item
        container
        onClick={handleOptionChange.bind(null, option2)}
        sx={option === option2 ? optionActive : {}}
      >
        <Typography
          fontFamily="Inter"
          fontWeight="600"
          fontSize="13px"
          lineHeight="18px"
          letterSpacing="0.16px"
        >
          {option2.length > 17 ? ` ${option2.slice(0, 17)}..` : option2}
        </Typography>
      </StyledGridButton>
    </StyledGridContainer>
  );
};

export default Switcher;
